import { ColumnType, GridDataType } from "../models";
var mockSuccessResultCode = "SUCCESS";
var mockGridStateServiceResponse = {
    resultCode: mockSuccessResultCode
};
var MockLegacyGridApi = /** @class */ (function () {
    function MockLegacyGridApi() {
    }
    MockLegacyGridApi.prototype.getProjectBaselineSummary = function () {
        return mockGridStateServiceResponse;
    };
    MockLegacyGridApi.prototype.createProjectBaseline = function () {
        return mockSuccessResultCode;
    };
    MockLegacyGridApi.prototype.removeProjectBaseline = function () {
        return mockSuccessResultCode;
    };
    MockLegacyGridApi.prototype.resetProjectBaseline = function () {
        return mockSuccessResultCode;
    };
    MockLegacyGridApi.prototype.setBaselineBarsDisplay = function () {
        return mockSuccessResultCode;
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.getAccessLevel = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.setAutomationColumnIds = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.getColumnCount = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.getRowCount = function () {
        return mockGridStateServiceResponse;
    };
    // /**
    //  * @deprecated
    //  */
    MockLegacyGridApi.prototype.getColumns = function () {
        return {
            data: [
                {
                    id: 1,
                    displayName: "mock display name",
                    columnType: ColumnType.COLUMNTYPE_TEXTNUMBER,
                    dataType: GridDataType.TEXT,
                    formula: "mock formula",
                    isPrimary: true
                }
            ],
            resultCode: "SUCCESS"
        };
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.getColumnsByIndex = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.getRowsByIndex = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * @deprecated
     */
    MockLegacyGridApi.prototype.getCellByRowAndColumnId = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * This method is not fully supported. It lacks safety checks and may be dangerous to use.
     * @deprecated
     */
    MockLegacyGridApi.prototype.insertColumnAndSave = function () {
        return mockGridStateServiceResponse;
    };
    /**
     * This method is not fully supported. It lacks safety checks and may be dangerous to use.
     * @deprecated
     */
    MockLegacyGridApi.prototype.removeColumnAndSave = function () {
        return mockGridStateServiceResponse;
    };
    MockLegacyGridApi.prototype.rowExists = function (rowId) {
        return false;
    };
    MockLegacyGridApi.prototype.rowExistsForGrid = function (rowId, gridId) {
        return false;
    };
    MockLegacyGridApi.prototype.isLoadComplete = function () {
        return false;
    };
    MockLegacyGridApi.prototype.saveRowForCallback = function (rowId, callback, forceSave, rightPanelRequest) {
        return;
    };
    MockLegacyGridApi.prototype.refreshDiscussionIconForRow = function (rowId, balloonType, updatedValue) {
        return;
    };
    MockLegacyGridApi.prototype.isRowLockRestricted = function (rowId) {
        return false;
    };
    MockLegacyGridApi.prototype.isRowSelectable = function (rowId) {
        return false;
    };
    MockLegacyGridApi.prototype.isRowFilteredOut = function (rowId) {
        return false;
    };
    MockLegacyGridApi.prototype.updateGridDataTimestampByGridId = function (gridId, dataTimestamp, modifyDateTime) {
        return;
    };
    MockLegacyGridApi.prototype.useTemplate = function (gridId) {
        return;
    };
    return MockLegacyGridApi;
}());
export { MockLegacyGridApi };
//# sourceMappingURL=MockLegacyGridBridgeDataClient.js.map